import React, { useEffect, useState } from "react";
import { Form, Button, Row, Col, Card, Spinner } from "react-bootstrap";
import { useAuth } from "../../hooks/useAuth";
import { crearDatos } from "../../api/common";
import SelectMult from "../SettingNot/SelectMult";
import { Modalcarga } from "../Modales/Modalcarga";
import { LoadingModal } from "../commons/LoadingSpiner";



const NewEventCalendar = ({ setEvents, events, setIsOpen, usuarios, setRefresh}) => {
  const { userData: { _id, nombre, apellido } } = useAuth();
  const [modalSpinner, setModalSpinner]=useState(false)

  const [newEvent, setNewEvent] = useState({
    title: "",
    descripcion: "",
    tipo: "OTRO",
    asistentes: [],
    prioridad: "MEDIA",
    fechaInicio: "",
    fechaFin: "",
    ubicacion: "",
    bgColor: "#3788d8",
    createdBy: _id,
  });


  const tiposActividad = [
    "CALIBRACION",
    "MANTENIMIENTO",
    "REUNION",
    "VISITA",
    "CAPACITACION",
    "ADMINISTRATIVA",
    "OTRO",
  ];

  const prioridades = ["BAJA", "MEDIA", "ALTA"];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewEvent({ ...newEvent, [name]: value });
  };

  const createEvent = async () => {
    try {
      setModalSpinner(true)
      const { data: { data } } = await crearDatos("Registro", newEvent);
      const formattedData = { ...data, id: data._id };
      setEvents([...events, formattedData]);
      setIsOpen(false);
      setModalSpinner(false)
      setRefresh(prev => !prev)
    } catch (error) {
      setIsOpen(false);
      setModalSpinner(false)
      console.error("Error creando actividad:", error);
    }
  };

  //Asistentes 
  const handleData =(event)=>{
    console.log(event)
         setNewEvent({
        ...newEvent,
        asistentes:event.target.value
    })
  }
  return (
    <>
  <LoadingModal show={modalSpinner} text="Creando evento, por favor espere..."/>
    <Card className="shadow-sm p-4 mx-auto" style={{ maxWidth: '700px', width: '100%' }}>
      <Form>
        <Form.Group className="mb-3">
          <Form.Label>Título</Form.Label>
          <Form.Control
            type="text"
            name="title"
            placeholder="Ej. Calibración equipos cliente XYZ"
            value={newEvent.titulo}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Row>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Fecha Inicio</Form.Label>
              <Form.Control
                type="datetime-local"
                name="fechaInicio"
                value={newEvent.fechaInicio}
                onChange={handleChange}
                required
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Fecha Fin</Form.Label>
              <Form.Control
                type="datetime-local"
                name="fechaFin"
                value={newEvent.fechaFin}
                onChange={handleChange}
                required
              />
            </Form.Group>
          </Col>
        </Row>

        <Form.Group className="mb-3">
          <Form.Label>Descripción</Form.Label>
          <Form.Control
            as="textarea"
            name="descripcion"
            rows={3}
            placeholder="Describe brevemente la actividad..."
            value={newEvent.descripcion}
            onChange={handleChange}
          />
        </Form.Group>

        <Row>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Tipo de actividad</Form.Label>
              <Form.Select
                name="tipo"
                value={newEvent.tipo}
                onChange={handleChange}
              >
                {tiposActividad.map((tipo) => (
                  <option key={tipo} value={tipo}>
                    {tipo}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Prioridad</Form.Label>
              <Form.Select
                name="prioridad"
                value={newEvent.prioridad}
                onChange={handleChange}
              >
                {prioridades.map((p) => (
                  <option key={p} value={p}>
                    {p}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>

        <Form.Group className="mb-3">
          <Form.Label>Participantes</Form.Label>
          <SelectMult
            dataDefault={[]}
            handledata={handleData}
            name='userAutorizados'
            collection={"Usuarios"}
            field={"nombre"}
            baseFilter={[ // Body para la consuta aggregate de mongo para metrologos y que esten activos.
                    {
                        "$match": {
                        'status': 'activo'
                        } 
                    },
                    {
                        "$lookup": {
                        "from": "roles",
                        "localField": "role",
                        "foreignField": "_id",
                        "as": "result"
                        }
                    },
                    {
                        "$match": {
                        "result.nombre": { $ne: "Cliente" } 
                        }
                    }
                    ]}
            />
          <Form.Text className="text-muted">
            Puedes seleccionar varios responsables (Ctrl + clic)
          </Form.Text>
        </Form.Group>

        <Row>
          <Col md={8}>
            <Form.Group className="mb-3">
              <Form.Label>Ubicación</Form.Label>
              <Form.Control
                type="text"
                name="ubicacion"
                placeholder="Ej. Sede principal / Cliente"
                value={newEvent.ubicacion}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Color en calendario</Form.Label>
              <Form.Control
                type="color"
                name="bgColor"
                value={newEvent.color}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>
        </Row>

        <div className="d-flex justify-content-end">
          <Button
            variant="secondary"
            className="me-2"
            onClick={() => setIsOpen(false)}
          >
            Cancelar
          </Button>
          <Button
            variant="primary"
            onClick={createEvent}
            disabled={
              !newEvent.title ||
              !newEvent.fechaInicio ||
              !newEvent.fechaFin
            }
          >
            Crear Actividad
          </Button>
        </div>
      </Form>
    </Card>

    </>
  );
};

export default NewEventCalendar;
